import React from 'react'
import PropTypes from 'prop-types'

import PatientListView from './View'
import GroupControls from './GroupControls'
import SearchFilters from './SearchFilters'
import FilterClearBar from '../../sitewide/Filter/FilterClearBar'

const PatientList = ({
  allLocationsChecked,
  currentPage,
  doctors,
  fetchNewPatientList,
  fetchNextPage,
  filterTimeRange,
  handleClearFilter,
  handleSearchChange,
  handleSortThenFetchPatients,
  hasDSO,
  patientsWithApptsInTimeRange,
  isFetching,
  isPreparingBlast,
  isTops,
  locations,
  onClickEdit,
  patients,
  patientStatuses,
  prepareBlastEmail,
  prepareBlastText,
  search,
  selectAppointmentDoctor,
  selectAppointmentLocation,
  selectedAppointmentTypeIds,
  selectedPatientStatusIds,
  selectedDoctorId,
  selectedLocationId,
  selectedMenu: { type },
  selectATypesAndPStatuses,
  sortCol,
  sortDir,
  totalPages,
  totalPatients,
  toggleAllLocations,
  userCountryCode,
}) => (
  <div style={{ height: '100%' }}>
    {isPreparingBlast ? (
      <p>Preparing message...</p>
    ) : (
      <GroupControls
        isCustomGroup={type === 'groups'}
        onClickEdit={onClickEdit}
        onClickEmail={prepareBlastEmail}
        onClickText={prepareBlastText}
      />
    )}
    <SearchFilters
      allLocationsChecked={allLocationsChecked}
      doctors={doctors}
      fetchNewPatientList={fetchNewPatientList}
      toggleAllLocations={toggleAllLocations}
      handleSearchChange={handleSearchChange}
      hasDSO={hasDSO}
      patientsWithApptsInTimeRange={patientsWithApptsInTimeRange}
      locations={locations}
      patientStatuses={patientStatuses}
      searchValue={search}
      select
      selectAppointmentDoctor={selectAppointmentDoctor}
      selectAppointmentLocation={selectAppointmentLocation}
      selectATypesAndPStatuses={selectATypesAndPStatuses}
      selectedAppointmentTypeIds={selectedAppointmentTypeIds}
      selectedDoctorId={selectedDoctorId}
      selectedLocationId={selectedLocationId}
      selectedPatientStatusIds={selectedPatientStatusIds}
    />
    <FilterClearBar
      handleClearFilter={handleClearFilter}
      selectedAppointmentTypeIds={selectedAppointmentTypeIds}
      selectedDoctorId={selectedDoctorId}
      filterTimeRange={filterTimeRange}
      selectedLocationId={selectedLocationId}
      selectedPatientStatusIds={selectedPatientStatusIds}
      totalPatients={totalPatients}
    />
    <PatientListView
      currentPage={currentPage}
      fetchNextPage={fetchNextPage}
      handleSortThenFetchPatients={handleSortThenFetchPatients}
      isTops={isTops}
      loading={isFetching}
      patients={patients}
      sortCol={sortCol}
      sortDir={sortDir}
      totalPages={totalPages}
      totalPatients={totalPatients}
      userCountryCode={userCountryCode}
    />
  </div>
)

PatientList.propTypes = {
  allLocationsChecked: PropTypes.bool.isRequired,
  currentPage: PropTypes.number.isRequired,
  doctors: PropTypes.arrayOf(PropTypes.object),
  fetchNewPatientList: PropTypes.func.isRequired,
  fetchNextPage: PropTypes.func.isRequired,
  filterTimeRange: PropTypes.string.isRequired,
  handleClearFilter: PropTypes.func.isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  handleSortThenFetchPatients: PropTypes.func.isRequired,
  hasDSO: PropTypes.bool.isRequired,
  patientsWithApptsInTimeRange: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isPreparingBlast: PropTypes.bool.isRequired,
  isTops: PropTypes.bool.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object),
  onClickEdit: PropTypes.func.isRequired,
  patients: PropTypes.arrayOf(PropTypes.object),
  patientStatuses: PropTypes.arrayOf(PropTypes.object).isRequired,
  prepareBlastEmail: PropTypes.func.isRequired,
  prepareBlastText: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  selectAppointmentDoctor: PropTypes.func.isRequired,
  selectAppointmentLocation: PropTypes.func.isRequired,
  selectedDoctorId: PropTypes.string.isRequired,
  selectedLocationId: PropTypes.string.isRequired,
  selectedMenu: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  selectATypesAndPStatuses: PropTypes.func.isRequired,
  selectedAppointmentTypeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedPatientStatusIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  sortCol: PropTypes.string.isRequired,
  sortDir: PropTypes.string.isRequired,
  totalPages: PropTypes.number.isRequired,
  totalPatients: PropTypes.number.isRequired,
  toggleAllLocations: PropTypes.func.isRequired,
  userCountryCode: PropTypes.string.isRequired,
}

export default PatientList



// WEBPACK FOOTER //
// ./src/components/PatientGroups/PatientList/index.js